import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  onClick
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full max-w-md mx-auto ${className}`} data-id="element-113">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={() => {
      if (window.fbq) {
        window.fbq('track', 'AddToCart');
      }
      window.location.href = 'https://www.braventoz.com/cart/48774054707450:1';
      onClick?.();
    }} className="w-full bg-brand-amber text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg hover:bg-amber-600 transition-colors duration-300 text-center" data-id="element-114">
        ¡DESCARGAR AHORA!
      </motion.button>
      <div className="flex items-center gap-2 mt-3 text-sm text-gray-500 font-medium" data-id="element-115">
        <ShieldCheck className="w-4 h-4 text-brand-teal" data-id="element-116" />
        <span data-id="element-117">
          Acceso instantáneo a tu guía digital después del pago seguro
        </span>
      </div>
    </div>;
}